import React from 'react';

import validationPatterns from 'common/validationPatterns';
import FormLabel from 'components/FormLabel';
import { useFormContext } from 'react-hook-form';
import { capitalize } from 'lodash';

type IInputEmail = {
  className?: string
  field: string
  name?: string
}

const InputEmail = ({ field, name, className }: IInputEmail) => {
  const { register } = useFormContext();
  const { email } = validationPatterns;
  const messageInvalid = 'A valid email is required';
  const messageRequired = 'Email can\'t be blank';

  return (
    <FormLabel name={name ? capitalize(name) : 'Email'} field={field} className={className}>
      <input
        type='email'
        {...register(field, {
          pattern: {
            message: messageInvalid,
            value: email,
          },
          required: messageRequired,
        })}
        placeholder='Email Address'
      />
    </FormLabel>
  );
};

export default InputEmail;